import Image from 'next/image';
import { useState } from 'react';
import { HamburgerMenu } from '../../../Header/HamburgerMenu';
import { THEME } from '../../../cms/layout/types';
import { getTextColor } from '../../../cms/layout/util';
import {
  DropdownComponent,
  TDropdownContentIntl,
} from '../InternationalComponents/DropdownComponent';
import {
  HEADER_LABELS /*RESOURCES_OPTIONS*/,
  PRODUCTS,
  RESOURCES_OPTIONS,
} from '../InternationalComponents/DropdownList.data';
import {
  GeneralDropdown,
  SolutionsDropdownMobile,
} from '../InternationalComponents/DropdownOptions';

const MobileNavBar = ({
  theme = THEME.light,
}: {
  theme?: THEME;
}): JSX.Element => {
  const [active, setActive] = useState(false);
  const textColor = getTextColor(theme);
  const logoSRC =
    theme === THEME.dark
      ? `https://assets1.cleartax-cdn.com/cleartax/images/1675151654_group1000002542.png`
      : 'https://assets1.cleartax-cdn.com/cleartax/images/1682581587_cleartechlight.png';
  const handleClick = () => {
    setActive(!active);
  };

  const header_labels = HEADER_LABELS;
  return (
    <>
      <div
        className={`${
          theme === THEME.dark ? 'bg-black' : 'bg-white'
        } p-3 w-full fixed top-0 z-20 font-medium sm:px-0`}
        data-testid="Header"
      >
        <nav className="flex items-center z-20 flex-wrap gap-2 md:w-full sm:w-full font-medium wg-container">
          <a href="/" className="inline-flex items-center p-0">
            <Image
              src={logoSRC}
              alt="Picture of the author"
              width={98.72}
              height={25.79}
            />
          </a>

          <div
            className={
              'inline-flex rounded gap-2 md:hidden lg:hidden xl:hidden text-grey-850 ml-auto'
            }
          >
            <HamburgerMenu handleMenuClick={handleClick} isOpen={active} />
          </div>

          <div
            data-testid="mobile-menu"
            className={`hidden ${active ? 'sm:block' : ''} ${
              theme === THEME.dark ? 'bg-black' : 'bg-white'
            }  w-full`}
          >
            <div className="w-full">
              <DropdownComponent
                dropdownLabel={header_labels.products}
                dropdownList={PRODUCTS}
                Dropdown={
                  GeneralDropdown as unknown as React.FC<TDropdownContentIntl>
                }
                classes="sm:p-0 sm:w-full"
                theme={theme}
              />
              <DropdownComponent
                dropdownLabel="Solutions"
                Dropdown={
                  SolutionsDropdownMobile as unknown as React.FC<TDropdownContentIntl>
                }
                classes="sm:p-0 sm:w-full"
                theme={theme}
              />
              <DropdownComponent
                dropdownLabel={header_labels.resources}
                dropdownList={RESOURCES_OPTIONS}
                Dropdown={
                  GeneralDropdown as unknown as React.FC<TDropdownContentIntl>
                }
                classes="sm:p-0 sm:w-full"
                theme={theme}
              />
              <a className={`${textColor} my-auto`} href="/about">
                About Us
              </a>
            </div>
          </div>
        </nav>
      </div>
      <div className="h-12"></div>
    </>
  );
};

export { MobileNavBar };
